module.exports = __webpack_public_path__ + "static/yt_2@1x-ef8cef40a9ad7599a8c7e4f197a8c903.jpg";